import { render, staticRenderFns } from "./buylist.vue?vue&type=template&id=2ebdf640&"
import script from "./buylist.vue?vue&type=script&lang=js&"
export * from "./buylist.vue?vue&type=script&lang=js&"
import style0 from "./buylist.vue?vue&type=style&index=0&id=2ebdf640&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports